import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'sonner';
export function Workshops() {
  const [filter, setFilter] = useState('All');
  const filters = ['All', 'Cooking', 'Cultural', 'Professional'];
  const workshops = [{
    id: 5,
    category: ['Cooking'],
    date: 'Tue Sept 29',
    time: '6–8 PM',
    title: 'How to make Risotto',
    instructor: 'Chef Manuel Quintero',
    blurb: 'Join Chef Manny of Side A for a hands-on risotto workshop. Learn the techniques behind achieving that perfect creamy texture, how to build layers of flavor, and how to make a dish that feels elegant and effortlessly at home.',
    price: 'Free',
    link: 'https://www.eventbrite.com/e/lets-make-risotto-with-chef-manuel-quintero-tickets-1999054550975',
    cta: 'Register on Eventbrite'
  }, {
    id: 2,
    category: ['Professional'],
    date: 'Mon November 9',
    time: '9 AM – 3 PM',
    title: 'Food Protection Manager Certification',
    instructor: 'Certified Instructor',
    blurb: 'Earn your accredited Food Protection Manager Certification. This course covers safe food handling, storage, and preparation, and includes the certification exam — ideal for vendors, chefs, and food entrepreneurs.',
    price: 'Free',
    note: 'Limited availability',
    cta: 'Register on Eventbrite',
    link: 'https://www.eventbrite.com/e/food-protection-manager-certification-course-exam-tickets-1998019092892'
  }];
  const filteredWorkshops = filter === 'All' ? workshops : workshops.filter(w => w.category.includes(filter));
  const handleReserve = () => {
    toast.success('Spot reserved! Check your email for details.');
  };
  return <section id="workshops" className="py-20 lg:py-32 bg-foodCard border-y-4 border-foodMaroon relative overflow-hidden" data-id="element-259" data-mp="2yuhg83n0clp0">
      {/* Decorative background element */}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-260" data-mp="38oq58hctxwif">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-261" data-mp="18p4cef2i0t7g">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="max-w-2xl" data-id="element-262" data-mp="13qt6ugj8l4v1">
            <h2 className="text-5xl md:text-6xl font-extrabold uppercase mb-4" data-id="element-263" data-mp="1rdhpx5jzf3d8">
              September Workshops & <span className="text-foodGold" data-id="element-264" data-mp="1nd7kbu03qeyw">Classes</span>
            </h2>
            <p className="text-xl font-medium" data-id="element-265" data-mp="21c768tw8cfrd">
              Roll up your sleeves this September. Every workshop is a free community
              experience — learn new skills, connect with neighbors, and eat
              what you make.
            </p>
          </motion.div>

          {/* Filters */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-wrap gap-2" data-id="element-266" data-mp="21fv7wrzxhb5">
            {filters.map(f => <button key={f} onClick={() => setFilter(f)} className={`px-4 py-2 font-bold border-2 border-foodMaroon transition-all ${filter === f ? 'bg-foodMaroon text-foodCream shadow-[2px_2px_0px_0px_#9C3A28]' : 'bg-foodCream text-foodMaroon hover:bg-foodGold hover:shadow-[2px_2px_0px_0px_#34302A]'}`} data-id="element-267" data-mp="28wrj0lu9rk70">
                {f}
              </button>)}
          </motion.div>
        </div>

        {/* Grid */}
        <motion.div layout className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-268" data-mp="1pzqef24mnm3l">
          <AnimatePresence data-id="element-269" data-mp="3fdmxy0b09kf1">
            {filteredWorkshops.map(workshop => <motion.div layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.3
          }} key={workshop.id} className="bg-foodCream border-4 border-foodMaroon p-6 flex flex-col h-full hover:-translate-y-2 hover:border-foodOrange hover:shadow-[8px_8px_0px_0px_#34302A] transition-all duration-300 group" data-id="element-270" data-mp="3kbel6h0pgicw">
                <div className="flex justify-between items-start mb-4" data-id="element-271" data-mp="sj0xfdkimr1p">
                  <div className="flex flex-col gap-1" data-id="element-272" data-mp="nkh7l22swv42">
                    <span className="bg-foodOrange text-white font-bold px-3 py-1 text-sm border-2 border-foodMaroon rotate-[-2deg] w-fit" data-id="element-273" data-mp="ikbmy5uy88vh">
                      {workshop.date}
                    </span>
                    <span className="text-foodMaroon/60 font-bold text-xs uppercase tracking-wider pl-1" data-id="element-274" data-mp="3hbjz8r539xq">
                      {workshop.time}
                    </span>
                  </div>
                  <div className="flex flex-col items-end" data-id="element-275" data-mp="dfhlvqcy4g2l">
                    <span className="font-display font-bold text-xl text-foodTomato uppercase" data-id="element-276" data-mp="dg0tad4yzm2d">
                      {workshop.price}
                    </span>
                    {workshop.note && <span className="text-[11px] font-medium text-foodMaroon/60 italic mt-0.5" data-id="element-277" data-mp="3gxr9q09u1c86">
                        {workshop.note}
                      </span>}
                  </div>
                </div>

                <h3 className="text-2xl font-extrabold uppercase mb-2 group-hover:text-foodOrange transition-colors" data-id="element-278" data-mp="3vl40c3ehy85f">
                  {workshop.title}
                </h3>
                <p className="text-foodMaroon/60 font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-279" data-mp="2y5gg6x12iqmq">
                  with {workshop.instructor}
                </p>
                <p className="mb-8 flex-grow font-medium" data-id="element-280" data-mp="2v3268zayib9l">{workshop.blurb}</p>

                {workshop.link ? <a href={workshop.link} target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-transparent border-4 border-foodMaroon text-foodMaroon font-bold py-3 hover:bg-foodMaroon hover:text-foodCream transition-colors mt-auto" data-id="element-281" data-mp="2q48zdpq6diie">
                    {workshop.cta || 'Reserve Free Spot'}
                  </a> : <button onClick={handleReserve} className="w-full bg-transparent border-4 border-foodMaroon text-foodMaroon font-bold py-3 hover:bg-foodMaroon hover:text-foodCream transition-colors mt-auto" data-id="element-282" data-mp="2m3ylzs01zpti">
                    {workshop.cta || 'Reserve Free Spot'}
                  </button>}
              </motion.div>)}
          </AnimatePresence>
        </motion.div>

        {filteredWorkshops.length === 0 && <div className="text-center py-20" data-id="element-283" data-mp="8wzb2qze76sq">
            <p className="text-2xl font-bold text-foodMaroon/50" data-id="element-284" data-mp="8y0jsosxrh7a">
              No workshops found for this category.
            </p>
          </div>}
      </div>
    </section>;
}